import { Modal, Textarea } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './CommentDialog.module.scss';

interface IAlertProps {
  label: string;
  subLabel?: string | null;
  show: boolean;
  onHide: () => void;
  btnContinueText?: string;
  btnCancelText?: string;
  onConfirm?: (comment: string) => void;
}

/**
 * Comment dialog
 */
const CommentDialog = ({ label, show, onHide, onConfirm, btnContinueText, btnCancelText, subLabel }: IAlertProps) => {
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [isText, setIsText] = useState<boolean>(false);
  const [authComment, setAuthComment] = useState<string>('');
  const { t: translate } = useTranslation();

  const handleCommentInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAuthComment(event.target.value);
  };

  useEffect(() => {
    if (!btnContinueText && !btnCancelText) {
      setIsText(false);
    } else { setIsText(true); }
  }, [btnContinueText, btnCancelText]);

  const handleCommentDialog = () => {
    if (onConfirm) {
      onConfirm(authComment);
      setShowDialog(false);
      setAuthComment('');
      onHide();
      setAuthComment('');
    }
  };

  const handleCancelDailog = () => {
    setShowDialog(false);
    onHide();
    setAuthComment('');
  };

  useEffect(() => {
    setShowDialog(show);
  }, [show]);

  const returnModalBody = (
    <div className={classes.modal} data-testid="returnModal">
      <div>
        <Textarea
          labelText={String(translate('comment_dialog.comment_event_form_label'))}
          isMandatory
          helperText={String(subLabel)}
          label=""
          value={authComment}
          onChange={handleCommentInputChange}
          placeholder={String(translate('comment_dialog.plchd_comment'))}
          name="comment"
          maxLength={501}
          data-testid="auth-comment"
          error={authComment.length > 500}
          errorTxt={String(translate('comment_dialog.rejection_reason_maxlength'))}
        />
      </div>
    </div>
  );

  return (
    <Modal
      modalTitle={label}
      modalBody={returnModalBody}
      modalShow={showDialog}
      btnSaveText={(isText ? btnCancelText : String(translate('comment_dialog.lbl_submit')))}
      btnCloseText={(isText ? btnContinueText : String(translate('comment_dialog.lbl_close')))}
      onCloseModal={handleCancelDailog}
      onSaveModal={handleCommentDialog}
      alignToCentre
      data-testid="returnReasonModalNodeConfirm"
      disableCloseBtn={false}
      disableSaveBtn={!authComment || authComment.length === 501}
      type="warning"
    />
  );
};
export default CommentDialog;
